import { useCreateMachine } from 'fsm';
import { CitationContext } from './context';
import { machine } from './machine';
import { jsx as _jsx } from "react/jsx-runtime";
export const CitationProvider = ({
  children,
  smartPropertyResultId
}) => {
  const citationMachine = useCreateMachine(machine, {
    initialContext: {
      smartPropertyResultId
    }
  });
  return /*#__PURE__*/_jsx(CitationContext.Provider, {
    value: citationMachine,
    children: children
  });
};